



























































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
@Component({
  name: "modal-add-space-component",
})
export default class ModalAddSpaceComponent extends mixins(NotificationEvent) {
  @Prop({ default: false }) active!: boolean;
  @Validate({ required })
  spaceName = "";
  loading = false;
  spaceTypes = [
    { id: 1, name: i18n.t(`spaceType.OFFICE_TYPE`), type: "OFFICE_TYPE" },
    { id: 2, name: i18n.t(`spaceType.EVENT_TYPE`), type: "EVENT_TYPE" },
    { id: 3, name: i18n.t(`spaceType.EKAM_TYPE`), type: "EKAM_TYPE" },
    { id: 4, name: i18n.t(`spaceType.MINISO_TYPE`), type: "MINISO_TYPE" },
    { id: 5, name: i18n.t(`spaceType.LEARNING_TYPE`), type: "LEARNING_TYPE" },
  ];
  spaces = [];
  @Validate({ required })
  selectType = "";
  @Validate({ required })
  selectSpace = -1;
  loadSpaces = false;
  get openModal(): boolean {
    return this.active;
  }
  set openModal(e) {
    this.$emit("close-modal", e);
  }
  getScenes(): void {
    this.loadSpaces = true;
    this.selectSpace = -1;
    this.spaces = [];
    let space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getScenesTypesAction", {
      spaceType: this.selectType,
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.loadSpaces = false;
        this.spaces = response;
        this.selectSpace = response[0].id;
      },
      callbackError: (error) => {
        this.loadSpaces = false;
      },
    });
  }
  addSpace(): void {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    const data = {
      name: this.spaceName,
      superSpace: space.superSpace.id,
      scenarioType: this.selectSpace,
      type: this.selectType,
    };
    this.$store.dispatch("SuperSpaceStore/setSpacesAction", {
      data,
      callback: (response) => {
        this.loading = false;
        this.openModal = false;
        this.onSuccess(
          this.$i18n.t("notifications.titles.success"),
          this.$i18n.t("notifications.descriptions.createSpace")
        );
        this.spaceName = "";
        this.selectType = "";
        this.selectSpace = -1;
        this.spaces = [];
        const getSpacesAvailablePage =
          this.$store.getters["SpaceStore/getSpacesAvailablePage"];
        this.$store.dispatch(
          "SpaceStore/setSpacesAvailablePageAction",
          getSpacesAvailablePage > 1 ? getSpacesAvailablePage - 1 : 1
        );
        this.getSpaces();
      },
      callbackError: (error) => {
        this.loading = false;
        this.openModal = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
  getSpaces(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space.superSpace.id,
      callback: (response) => {
        // do nothing
      },
      callbackError: (error) => {
        // do nothing
      },
    });
  }
  get imageScenne() {
    if (this.selectSpace > 0) {
      return this.spaces.filter((a) => a.id == this.selectSpace)[0];
    }
    return null;
  }
}
